import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { UniversalConfig } from '@application/universal_config.service';
import { ProgrammaticBrowserRouter } from '@cortex-shim/programmatic_browser_router.component';
import { LocationSelectorService } from '@public/src/application/services/location_selector.service';
import { sharedResolution } from '@public/src/shared_resolution';
import { ViewAppointment } from '@view/view_appointment/view_appointment.component';
import { createRoot, Root } from 'react-dom/client';
import { Route, Routes, useLocation } from 'react-router-dom';
import { SpaEventService } from '../app/Services/spaEvents.service';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';

const containerElementName = 'SignInWrapper';

@Component({
	standalone: false,
	styleUrls: ['./css/appointment.wrapper.scss'],
	selector: 'appointment-wrapper',
	template: ` <div class="wrapper-container" #${containerElementName}></div> `,
	encapsulation: ViewEncapsulation.None,
})
export class AppointmentWrapperComponent implements OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;

	constructor(
		private readonly ngZone: NgZone,
		// biome-ignore lint/correctness/noUnusedPrivateClassMembers: suppressed due to migration - should be fixed
		private readonly spaEventService: SpaEventService,
	) {
		// Empty
	}

	ngAfterViewInit() {
		this.render();
	}

	ngOnDestroy() {
		this.root?.unmount();
	}

	private async render() {
		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		const universalConfigService = sharedResolution.resolve(UniversalConfig);
		const locationSelectorService = sharedResolution.resolve(LocationSelectorService);

		const split = locationSelectorService.location.route.split('/');
		split.splice(0, 1);
		const routeBase = split.join('/');

		this.ngZone.runOutsideAngular(() => {
			root.render(
				<CellulaProviderWrapper useGlobals>
					<ProgrammaticBrowserRouter basename={universalConfigService.alias} forceNewHistory>
						<Routes>
							<Route path={routeBase}>
								<Route path='appointment/:ticket' element={<ViewAppointment />} />
							</Route>
							<Route path='*' element={<FunkyRedirect />} />
						</Routes>
					</ProgrammaticBrowserRouter>
				</CellulaProviderWrapper>,
			);
		});
	}
}

function FunkyRedirect() {
	const { pathname } = useLocation();

	if (window.__TEMP__overrideNavigation) {
		window.__TEMP__overrideNavigation(pathname);
	}

	return null;
}
